export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-time-line',
      title: '灵活学习，随时随地',
      description: '支持手机、平板、电脑全终端学习，课程终身回看，按照自己的节奏安排学习计划，工作学习两不误。',
    },
    {
      icon: 'ri-award-line',
      title: '权威认证，含金量高',
      description: '与权威认证机构合作，提供PMP、CPA等专业证书备考课程，考试通过率高，证书行业认可度强。',
    },
    {
      icon: 'ri-team-line',
      title: '资深讲师，实战教学',
      description: '200+行业资深讲师团队，平均10年以上从业经验，课程内容紧贴企业实际需求，学完即用。',
    },
    {
      icon: 'ri-chat-smile-2-line',
      title: '社群陪伴，答疑解惑',
      description: '每门课程配备专属学习社群，讲师在线答疑，同学互相督促，学习路上不再孤单。',
    },
    {
      icon: 'ri-refund-2-line',
      title: '7天无理由退款',
      description: '课程不满意7天内全额退款，无需任何理由，让你零风险开始学习之旅。',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: '数据追踪，见证成长',
      description: '学习进度可视化，技能雷达图直观展示成长轨迹，让每一点进步都有据可循。',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            六大核心优势，让成人在线学习更高效、更省心
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div key={feat.title} className="p-6 rounded-2xl bg-background-100 border border-background-200/60 hover:border-accent-200 transition-all duration-300">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}